<template>
  <v-card class="rounded-lg white">
    <span v-show="false" class="secondary--text">{{ title }}</span>
    <v-card-title>
      <v-col cols="12" md="2" v-if="detailed">
        <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            class="rounded-lg"
            label="سطح حساب"
            v-model="filters.level"
            item-text="text"
            item-value="value"
            :items="accountLevels"
            :return-object="false"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            class="rounded-lg"
            :items="accountStatuses"
            v-model="filters.status"
            label="وضعیت حساب"
        />
      </v-col>
      <v-col cols="12" md="2">
        <date placeholder="از تاریخ" v-model="filters.from_date"/>
      </v-col>
      <v-col cols="12" md="2">
        <date placeholder="تا تاریخ" v-model="filters.to_date"/>
      </v-col>
      <v-col cols="12" md="2">
        <v-switch
            inset
            color="success"
            class="mr-md-3 mt-3 mt-md-1"
            label="در نظر نگرفتن سند بستن"
            v-model="filters.skip_closing_sanads"
        ></v-switch>
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
            :block="isXs"
            depressed
            class="success rounded-lg white--text w-100px mt-1 mr-5 md-5  "
            @click="getData()"
        >گزارش
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
          icon
          :href="this.endpoint('reports/newBalanceSheet/html') + `?detailed=${detailed == true}&token=${token}`"
          target="_blank"
          depressed
          class="secondary--text export-btn  mr-md-2 ">
        <v-img max-height="22" max-width="22" src="/img/icons/print_icon.svg"></v-img>
      </v-btn>
      <v-btn
          :href="this.endpoint('reports/newBalanceSheet/pdf') + `?detailed=${detailed == true}&token=${token}`"
          target="_blank"
          depressed
          icon
          class="secondary--text export-btn  mr-md-2"
      >
        <v-img max-height="22" max-width="22" src="/img/icons/pdf.svg"></v-img>
      </v-btn>

      <v-btn
          :href="this.endpoint('reports/newBalanceSheet/xlsx') + `?detailed=${detailed == true}&token=${token}`"
          target="_blank"
          depressed
          icon
          class="secondary--text export-btn  mr-md-2"
      >
        <v-img max-height="18" max-width="16" src="/img/icons/xls.svg"></v-img>
      </v-btn>

    </v-card-title>


    <v-row>

      <template v-if="!_.isEmpty(d)">
        <v-col cols="12" md="6">
          <v-simple-table class="rounded">
            <thead class="back">
            <tr>
              <th colspan="2" class="text-center secondary white--text">دارایی ها</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th colspan="2" class="tableHeader secondary--text text-center">دارایی های جاری</th>
            </tr>
            <tr>
              <td>{{ d.cacheAndBank.name }}</td>
              <td>{{ d.cacheAndBank.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.shortTimeInvestments.name }}</td>
              <td>{{ d.shortTimeInvestments.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.investmentImpairmentReserve.name }}</td>
              <td class="error--text">{{ d.investmentImpairmentReserve.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.commercialAccountsAndReceivables.name }}</td>
              <td>{{ d.commercialAccountsAndReceivables.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.impairmentReserveTradeReceivables.name }}</td>
              <td class="error--text">{{ d.impairmentReserveTradeReceivables.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.storageOfCurrentDoubtfulReceivables.name }}</td>
              <td class="error--text">{{ d.storageOfCurrentDoubtfulReceivables.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.otherAccountsAndReceivables.name }}</td>
              <td>{{ d.otherAccountsAndReceivables.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.impairmentReserveNonTradeReceivables.name }}</td>
              <td class="error--text">{{ d.impairmentReserveNonTradeReceivables.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.inventories.name }}</td>
              <td>{{ d.inventories.remain }}</td>
            </tr>

            <tr>
              <td>{{ d.inventoryImpairmentReserve.name }}</td>
              <td class="error--text">{{ d.inventoryImpairmentReserve.remain }}</td>
            </tr>

            <tr>
              <td>{{ d.ordersAndPrepayments.name }}</td>
              <td>{{ d.ordersAndPrepayments.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.nonCurrentAssetsHeldForSale.name }}</td>
              <td>{{ d.nonCurrentAssetsHeldForSale.remain }}</td>
            </tr>
            <tr class="font-weight-bold">
              <td>{{ d.totalCurrentAssets.name }}</td>
              <td>{{ d.totalCurrentAssets.remain }}</td>
            </tr>
            <tr>
              <th colspan="2" class="tableHeader secondary--text text-center">دارایی های غیر جاری</th>
            </tr>
            <tr>
              <td>{{ d.evidentFixedAssets.name }}</td>
              <td>{{ d.evidentFixedAssets.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.intangibleAssetsAccumulatedDepreciation.name }}</td>
              <td class="error--text">{{ d.intangibleAssetsAccumulatedDepreciation.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.realEstateInvestment.name }}</td>
              <td>{{ d.realEstateInvestment.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.notEvidentAssets.name }}</td>
              <td>{{ d.notEvidentAssets.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.tangibleAssetsAccumulatedDepreciation.name }}</td>
              <td class="error--text">{{ d.tangibleAssetsAccumulatedDepreciation.remain }}</td>
            </tr>

            <tr>
              <td>{{ d.longTimeInvestments.name }}</td>
              <td>{{ d.longTimeInvestments.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.longTermPayableDocumentsAndAccounts.name }}</td>
              <td>{{ d.longTermPayableDocumentsAndAccounts.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.impairmentReserveLongTermReceivables.name }}</td>
              <td class="error--text">{{ d.impairmentReserveLongTermReceivables.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.storageOfLongTermDoubtfulReceivables.name }}</td>
              <td class="error--text">{{ d.storageOfLongTermDoubtfulReceivables.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.otherAssets.name }}</td>
              <td>{{ d.otherAssets.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.accumulatedDepreciationOtherAssets.name }}</td>
              <td class="error--text">{{ d.accumulatedDepreciationOtherAssets.remain }}</td>
            </tr>

            <tr class="font-weight-bold">
              <td>{{ d.totalNotCurrentAssets.name }}</td>
              <td>{{ d.totalNotCurrentAssets.remain }}</td>
            </tr>
            <tr class="font-weight-bold info--text">
              <td>{{ d.totalAssets.name }}</td>
              <td>{{ d.totalAssets.remain }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="12" md="6">
          <v-simple-table dense>
            <thead class="grey lighten-3">
            <tr>
              <th colspan="2" class="text-center secondary white--text">حقوق مالکانه و بدهی ها</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th colspan="2" class="tableHeader secondary--text text-center">بدهی های جاری</th>
            </tr>
            <tr>
              <td>{{ d.businessAccountsAndPayableDocuments.name }}</td>
              <td>{{ d.businessAccountsAndPayableDocuments.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.otherAccountsAndPayableDocuments.name }}</td>
              <td>{{ d.otherAccountsAndPayableDocuments.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.payableTaxes.name }}</td>
              <td>{{ d.payableTaxes.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.dividendsPayable.name }}</td>
              <td>{{ d.dividendsPayable.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.receivableFunds.name }}</td>
              <td>{{ d.receivableFunds.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.saveTypes.name }}</td>
              <td>{{ d.saveTypes.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.prepayments.name }}</td>
              <td>{{ d.prepayments.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.nonCurrentAssetsHeldForSaleDebt.name }}</td>
              <td>{{ d.nonCurrentAssetsHeldForSaleDebt.remain }}</td>
            </tr>
            <tr class="font-weight-bold">
              <td>{{ d.totalCurrentDebt.name }}</td>
              <td>{{ d.totalCurrentDebt.remain }}</td>
            </tr>
            <tr>
              <th colspan="2" class="tableHeader secondary--text text-center">بدهی های غیر جاری</th>
            </tr>
            <tr>
              <td>{{ d.longtermAccountsAndPayableDocuments.name }}</td>
              <td>{{ d.longtermAccountsAndPayableDocuments.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.longtermReceivableFunds.name }}</td>
              <td>{{ d.longtermReceivableFunds.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.savedEndingServiceBenefits.name }}</td>
              <td>{{ d.savedEndingServiceBenefits.remain }}</td>
            </tr>
            <tr class="font-weight-bold">
              <td>{{ d.totalNotCurrentDebt.name }}</td>
              <td>{{ d.totalNotCurrentDebt.remain }}</td>
            </tr>
            <tr>
              <th colspan="2" class="tableHeader secondary--text text-center">حقوق مالکانه</th>
            </tr>
            <tr>
              <td>{{ d.fund.name }}</td>
              <td>{{ d.fund.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.capitalIncreaseInProgress.name }}</td>
              <td>{{ d.capitalIncreaseInProgress.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.spendOnStocks.name }}</td>
              <td>{{ d.spendOnStocks.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.savings.name }}</td>
              <td>{{ d.savings.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.extraAssessmentRenewal.name }}</td>
              <td>{{ d.extraAssessmentRenewal.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.foreignOperationExchangeRateDifferences.name }}</td>
              <td>{{ d.foreignOperationExchangeRateDifferences.remain }}</td>
            </tr>
            <tr>
              <td>{{ d.accumulatedProfit.name }}</td>
              <td>{{ d.accumulatedProfit.remain }}</td>
            </tr>
            <tr class="font-weight-bold">
              <td>{{ d.equitiesSum.name }}</td>
              <td>{{ d.equitiesSum.remain }}</td>
            </tr>
            <tr class="font-weight-bold info--text">
              <td>{{ d.totalDebtsAndEquities.name }}</td>
              <td>{{ d.totalDebtsAndEquities.remain }}</td>
            </tr>
            <tr :class="(d.remainDifference.remain)?
              'font-weight-bold primary--text':'font-weight-bold success--text'"
                style="font-size: larger"
            >
              <td>{{ d.remainDifference.name }}</td>
              <td v-if="d.remainDifference.remain">{{ d.remainDifference.remain }}</td>
              <td v-else>ندارد</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </template>
    </v-row>
  </v-card>
</template>

<script>
import date from "@/components/mcomponents/cleave/Date";
import _ from "lodash";

export default {
  name: "NewBalanceSheet",
  components: {date},
  props: {
    detailed: {
      default: false,
    },
    isDialog: {
      default: false
    },
  },
  data() {
    return {
      d: {},
      filters: {level: 3, status: 'with_transaction', skip_closing_sanads: false},
      accountStatuses: [
        {value: "all", text: "همه"},
        {value: "with_remain", text: "حساب های دارای مانده"},
        {value: "with_transaction", text: "حساب های دارای گردش"},
      ],
      accountLevels: [
        {value: 1, text: "کل"},
        {value: 2, text: "معین"},
        {value: 3, text: "تفضیلی"},
      ],
    };
  },
  created() {
    this.getData();
  },
  updated() {
    if (this.$route.params.detailed) {
      this.detailed = true
    }

  },

  methods: {
    getData() {
      let filters = {};
      for (const k of Object.keys(this.filters)) {
        if (["undefined", ""].includes(this.filters[k])) return;
        if (k.includes("date") || k.includes("due")) {
          let gDate = this.toGDate(this.filters[k]);
          if (gDate == "Invalid date") {
            this.notify("فرمت تاریخ وارد شده معتبر نمی باشد", "danger");
            return;
          }
          filters[k] = gDate;
        } else {
          filters[k] = this.filters[k];
        }
      }

      return this.request({
        url: this.endpoint("reports/newBalanceSheet"),
        method: "get",
        params: {
          ...this.filters,
        },
        success: (data) => {
          this.d = data;
          Object.keys(this.d).forEach((k) => {
            this.d[k].remain = this.toMoney(this.d[k].remain);
          });
        },
      });
    },
  },
  computed: {
    _() {
      return _;
    },
    title() {
      return this.setDocumentTitle('ترازنامه کلی')
    },

  },
};
</script>

<style scoped lang="scss">
th {
  text-align: center;
}

td {
  width: 50%;
}

tr td:nth-child(2) {
  text-align: left;
  direction: ltr;
}
</style>
